import { useState } from "react";
import { useModal } from "../../../../utils/ModalContext";
import { FaDiscord, FaTwitter, FaWallet } from "react-icons/fa";
import { BsXLg } from "react-icons/bs";
import Button from "../../../../common/button";
import logo from "../../../../assets/images/mint-logo.png";
import openseaIcon from "../../../../assets/images/icon/opensea.svg";

import {
  isWalletConnected,
  disconnectWallet,
} from "../../../../lib/metamaskhandler";

import MobileMenuStyleWrapper from "./MobileMenu.style";

const MobileMenu = ({ mobileMenuhandle }) => {
  const { walletModalHandle, setConnect } = useModal();

  const handleMetamaskDisconnect = async (e) => {
    e.preventDefault();
    setConnect(false);
    disconnectWallet();
  };

  return (
    <MobileMenuStyleWrapper className="bithu_mobile_menu">
      <div className="bithu_mobile_menu_content">
        <div className="mobile_menu_logo">
          <img className="bithu_logo" src={logo} alt="bithu logo" />
          <button
            className="mobile_menu_close_btn"
            onClick={() => mobileMenuhandle()}
          >
            {" "}
            <BsXLg />{" "}
          </button>
        </div>
        <div className="bithu_mobile_menu_list">
          <ul>
            <li>
              <a href="/">Season 1</a>
            </li>
            {/* <li>
              <a href="/free-mint">Free Mint</a>
            </li> */}
            <li>
              <a href="/faq">FAQ</a>
            </li>
          </ul>
        </div>
        <div className="mobile_menu_social_links">
          <a href="# ">
            <img src={openseaIcon} alt="bithu social icon" />
          </a>
          <a href="https://twitter.com/coderblock">
            <FaTwitter />
          </a>
          <a href="https://discord.gg/coderblock">
            <FaDiscord />
          </a>
        </div>
        {!isWalletConnected() ? (
          <Button
            sm
            variant="hovered"
            className="connect_btn"
            onClick={() => walletModalHandle()}
          >
            <FaWallet />
            Connect
          </Button>
        ) : (
          <Button
            sm
            variant="hovered"
            className="connect_btn"
            onClick={(e) => handleMetamaskDisconnect(e)}
          >
            <FaWallet />
            Disconnect
          </Button>
        )}
      </div>
    </MobileMenuStyleWrapper>
  );
};

export default MobileMenu;
